import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ReactivosService } from "app/main/wizard-cgo/services/reactivos.service";
import * as backInter from 'app/auth/auth-data.model';
import Swal from 'sweetalert2';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
import { AdicionalesService } from 'app/main/wizard-cgo/services/adicionales.service';

import {lang_modales } from 'app/idiomas/i18n/modales/modales.lang';

@Component({
  selector: 'reactivos',
  templateUrl: './reactivos.component.html',
  styleUrls: ['./reactivos.component.scss']
})
export class ReactivosComponent implements OnInit {

  opened:boolean;
  plantillas:any;
  plantillaElegida: any;
  numPlantilla: number;
idPreview:string;
  reactivosNativo: any;
  idiomas: backInter.getIdiomas;
  idioma1oMas:boolean;

  guardados: any;
  cargando = true;
  pasoCompleto=false;
    @Output() actualizarAdicionales: EventEmitter<boolean> = new EventEmitter();


  constructor(
    private reactivosService: ReactivosService,
    private translateSrv: TranslateService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private adicionalesService: AdicionalesService,
  ) {

    lang_modales.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });

  }

  ngOnInit() {
this.obtieneIdiomasGuardados();

    this.getPlantillas();

    this.reactivosService.getStatusReactivosFocus(localStorage.getItem('encuestaID')).subscribe( (data: backInter.getStatusIndiv) => {
      console.log(data);
      if(data.estatus === 3)
        this.pasoCompleto = true;
    });
    // this.getReactivosGuardados();
  }

  obtieneIdiomasGuardados(){
    let fechaProducto: backInter.getIdiomaFechas = {fechaFocus: parseInt(localStorage.getItem('FechaFocusArea'))};
    this.adicionalesService.getListaIdiomasFocus().subscribe( (data: backInter.getIdiomas) => {
      this.idiomas = data;
      this.idiomas.idiomas.forEach(element => {
        console.log(element.tipoIdioma);
        if (parseInt(element.tipoIdioma)==3) {
          this.idioma1oMas=true;
          console.log("solo un Idioma");

        }else{
          this.idioma1oMas=false;
          console.log("Varios Idiomas");

        }

      });
      console.log(data);
    });
  }




  getPlantillas(){
    this.reactivosService.getPlantillas().subscribe((respuesta:any) => {
      console.log(respuesta);
      if(respuesta.message == "Success"){
        this.plantillas = respuesta.plantillasMostrar;
        setTimeout(() => {
          this.opened = true;
        }, 500);
      }
    });
  }

  eligePlantilla(plantilla:any, numero:number){
    if(this.numPlantilla != numero){
      this.plantillaElegida = plantilla;
      this.numPlantilla = numero;
      this.cargando = true;
      this.getReactivosPlantilla();
    }
  }

  getReactivosPlantilla(){
    let datos = {
      encuestaID: localStorage.getItem('encuestaID'),
      idPlantilla: this.plantillaElegida.plantillaId
    }
    this.reactivosNativo = null;
    this.reactivosService.getReactivos(datos).subscribe((respuesta:any) => {
      console.log(respuesta);
      if(respuesta.success){
        // this.reactivosNativo = respuesta.reactivosNat;
        this.getReactivosGuardados(respuesta.reactivosNat);
      }
    });
  }

   pasoCompletoFinal(status:boolean){
     this.pasoCompleto=status;
     console.log(status);

   }
  getReactivosGuardados(listaReactivos: any[]){
    this.reactivosService.getGuardados(localStorage.getItem('encuestaID')).subscribe((respuesta:any) => {
      console.log(respuesta);
      this.guardados = respuesta;
      let arregloPreguntas: any[] = [];
      respuesta.preguntas.forEach(pregunta => {
        if(pregunta.plantillaId == this.plantillaElegida.plantillaId){
          arregloPreguntas.push(pregunta);
        }
      });
      // this.reactivosNativo.forEach(reactivo => {
      listaReactivos.forEach(reactivo => {
        var BreakException = {};
        try {
          arregloPreguntas.forEach(pregunta => {
            if(pregunta.pregunta == reactivo.pregunta){
              reactivo.guardado = true;
              reactivo._id = pregunta._id;
              throw BreakException;
            }
          });
        } catch (e) {
            if (e !== BreakException) throw e;
        };

      });
      this.reactivosNativo = listaReactivos;
      console.log("reacnativoDesp:",this.reactivosNativo);
      this.cargando = false;
    });
  }

  guardaReactivo(event){
    console.log("event: ",event);
    let infoPregunta = event.option._value;
    let idpregunta:any;
    let datos={};

    if(event.option._selected){
      console.log("guarda reactivo");
      datos = {
        tipoRespuesta: '' + infoPregunta.tipoRespuesta + '',
        seccion: '' + infoPregunta.seccion + '',
        orden: '' + infoPregunta.orden + '',
        pregunta: infoPregunta.pregunta,
        requerido: '' + infoPregunta.requerido + '',
        plantillaId: this.plantillaElegida.plantillaId
      };
    this.modalCargaReactivo();
      this.reactivosService.guardaReactivo(localStorage.getItem('encuestaID'), datos).subscribe((respuesta:any) => {
        console.log(respuesta);
        if (this.idioma1oMas) {
          console.log("solo un Idioma");

          Swal.close();
          this.idPreview= respuesta.preguntaMostrar._id;
          this.actualizarAdicionales.emit(true);

        }else{
        console.log("son 2 o mas Idiomas");

        if (respuesta.preguntaMostrar.traducciones.length==0) {
          Swal.close();
          let rspSi = 'MODALES.ACCIONES.aceptar';
          let texto = 'MODALES.VALIDACION.WARNING-SIN-TRADUCCION';
          this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
          this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; })
          Swal.fire({
            icon: 'warning',
            title: texto,
            confirmButtonText: rspSi,
            confirmButtonColor: '#e40601'
          });
          this.idPreview= respuesta.preguntaMostrar._id;
          this.actualizarAdicionales.emit(true);
        }else{
          Swal.close();
          this.idPreview= respuesta.preguntaMostrar._id;
          this.actualizarAdicionales.emit(true);
        }
      }


      });

    }
    else{
      //funcion elimina reactivos pendiente
      if (infoPregunta._id) {
      datos = {
          preguntaId: infoPregunta._id
        };
        console.log("pregunta existente ",datos);

      }else{
      datos = {
          preguntaId: this.idPreview
        };
        console.log("pregunta nueva ",datos);

      }
      console.log("borra reactivo");

      // console.log(datos);
      this.reactivosService.borraReactivo(localStorage.getItem('encuestaID'), datos).subscribe((respuesta:any) => {
        console.log(respuesta);

      });

    }
  }


  modalCargaReactivo(){
    let mensaje: string;
    this.translateSrv.get('MODALES.VALIDACION.MODAL-GUARDANDO').subscribe((res: string) => { mensaje = res; });

    Swal.fire({
      title: mensaje,
      allowOutsideClick: false,

      didOpen: () => {
        Swal.showLoading()
      }
    });
  }



}
